import { useState } from "react";
import { CloseIcon, CopyableCell, formatDate } from "../../../common/functions";

let selectButtonStyle: any = {
  backgroundColor: "#144276",
  color: "white",
  border: "none",
  borderRadius: 0,
  fontSize: "12px",
  lineHeight: "1",
  padding: "4px 8px",
  cursor: "pointer",
  whiteSpace: "nowrap",
};

let tableTitlesDealerRuns: string[] = [
  "Broker",
  "Broker Email",
  "Trader",
  "Security",
  "ISIN",
  "Updated",
  "Source",
  "Currency",
  "Bid Price",
  "Bid Yield",
  "Bid Size (MM)",
  "Bid Axe",
  "",
  "Ask Price",
  "Ask Yield",
  "Ask Size (MM)",
  "Ask Axe",
  "",
  "Rating",
  "CUSIP",
  "Tranche",
  "Bid Z-Spread",
  "Bid Spread",
  "Bid G-Spread",
  "Bid DM",
  "Bid I-Spread",
  "Bid Sprd Chg",
  "Ask Z-Spread",
  "Ask Spread",
  "Ask G-Spread",
  "Ask DM",
  "Ask I-Spread",
  "Ask Px Chg (Close)",
  "Next Call Date",
  "Full Maturity",
  "Benchmark",
  "CDS Ticker",
  "Indicative",
  "Notes",
  "Other Fields",
];

function ViewDealerRuns(props: any) {
  let positionInfo = props.positionInfo || {};
  let quotes = positionInfo["__dealerRunQuotes"] || [];
  let bbTicker = positionInfo["BB Ticker"] || "";
  let isin = positionInfo["ISIN"] || "";
  let location = positionInfo["Location"] || "";
  let matchMethod = positionInfo["__dealerRunMatchMethod"] || "";

  let [selected, setSelected]: any = useState(null);

  let bids = quotes.filter((quote: any) => quote.bidPrice && !isNaN(parseFloat(quote.bidPrice)));
  let asks = quotes.filter((quote: any) => quote.askPrice && !isNaN(parseFloat(quote.askPrice)));
  let bestBid = bids.length ? bids.reduce((best: any, quote: any) => (parseFloat(quote.bidPrice) > parseFloat(best.bidPrice) ? quote : best)) : null;
  let bestAsk = asks.length ? asks.reduce((best: any, quote: any) => (parseFloat(quote.askPrice) < parseFloat(best.askPrice) ? quote : best)) : null;

  function selectPrice(quote: any, side: "Bid" | "Ask") {
    let selection = {
      side: side,
      price: side === "Bid" ? quote.bidPrice : quote.askPrice,
      bank: quote.bank,
      trader: quote.trader,
      currency: quote.currency,
      updated: quote.updated,
    };
    setSelected(selection);
    if (props.onSelectPrice) {
      props.onSelectPrice(positionInfo, selection);
    }
  }

  return (
    <div className="edit-info-container-1">
      <div onClick={(event) => props.setDealerRunsCardDisplay("none")}>
        <CloseIcon classNameInput="rlzd-close-icon" />
      </div>

      <div className="trades-inputs position-container rlzd-trades-info-container-2 rlzd-trades-card">
        <div className="rlzd-trades-titles" style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px", marginBottom: "10px" }}>
          <h4 style={{ margin: 0, fontWeight: 600 }}>Dealer Runs</h4>
          <p style={{ margin: "5px 0 0 0", color: "#555", fontSize: "14px" }}>
            {bbTicker} | {isin} | {location}
          </p>
          {matchMethod ? (
            <p style={{ margin: "3px 0 0 0", color: "#888", fontSize: "12px" }}>
              Matched via {matchMethod === "isin" ? "ISIN" : matchMethod === "bloomberg_id" ? "Bloomberg ID" : "BB Ticker"}
            </p>
          ) : (
            ""
          )}

          {bestBid || bestAsk ? (
            <div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
              {bestBid ? (
                <p style={{ margin: 0, fontSize: "13px" }}>
                  Best Bid: <strong>{bestBid.bidPrice}</strong> ({bestBid.bank})
                </p>
              ) : (
                ""
              )}
              {bestAsk ? (
                <p style={{ margin: 0, fontSize: "13px" }}>
                  Best Ask: <strong>{bestAsk.askPrice}</strong> ({bestAsk.bank})
                </p>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}

          {selected ? (
            <div style={{ marginTop: "8px", padding: "8px 12px", backgroundColor: "#e8f5e9", borderRadius: "4px", fontSize: "13px" }}>
              Selected for portfolio: <strong>{selected.side}</strong> {selected.price} {selected.currency || ""} @ {selected.bank}
              {selected.trader ? " \u00b7 " + selected.trader : ""}
            </div>
          ) : (
            ""
          )}
        </div>

        <div
          style={{
            width: "100%",
          }}
          className="table-container-custom"
        >
          {quotes.length > 0 ? (
            <>
              <p style={{ marginBottom: "10px", color: "#666" }}>Total quotes: {quotes.length}</p>
              <table
                id="dealer-runs-table"
                className="table table-hover table-striped table-dealer-runs"
              >
                <tbody>
                  <tr className="sticky-top table-header">
                    {tableTitlesDealerRuns.map((title: string, index: number) => (
                      <td key={index}>{title}</td>
                    ))}
                  </tr>

                  {quotes.map((quote: any, index: number) => {
                    let isRowSelected = selected && selected.bank === quote.bank && selected.updated === quote.updated;
                    return (
                      <tr key={index} className="table-body" style={isRowSelected ? { backgroundColor: "#e8f5e9" } : {}}>
                        <CopyableCell text={quote.bank || ""} />
                        <CopyableCell text={quote.brokerEmail || ""} />
                        <CopyableCell text={quote.trader || ""} />
                        <CopyableCell text={quote.bbTickerRaw || [quote.issuer, quote.couponRaw || quote.coupon, quote.isPerp ? "PERP" : quote.maturityYear].filter(Boolean).join(" ")} />
                        <CopyableCell text={quote.isin ? quote.isin + (quote.isinInferred ? " *" : "") : ""} />
                        <CopyableCell text={quote.updated ? formatDate(quote.updated) : ""} />
                        <CopyableCell text={quote.subject || ""} />
                        <CopyableCell text={quote.currency || ""} />
                        <CopyableCell text={quote.bidPrice || ""} />
                        <CopyableCell text={quote.bidYield || ""} />
                        <CopyableCell text={quote.bidSize || ""} />
                        <CopyableCell text={quote.bidAxeRaw || ""} />
                        <td>
                          {quote.bidPrice ? (
                            <button style={selectButtonStyle} onClick={() => selectPrice(quote, "Bid")}>
                              Select
                            </button>
                          ) : (
                            ""
                          )}
                        </td>
                        <CopyableCell text={quote.askPrice || ""} />
                        <CopyableCell text={quote.askYield || ""} />
                        <CopyableCell text={quote.askSize || ""} />
                        <CopyableCell text={quote.askAxeRaw || ""} />
                        <td>
                          {quote.askPrice ? (
                            <button style={selectButtonStyle} onClick={() => selectPrice(quote, "Ask")}>
                              Select
                            </button>
                          ) : (
                            ""
                          )}
                        </td>
                        <CopyableCell text={quote.rating || ""} />
                        <CopyableCell text={quote.cusip || ""} />
                        <CopyableCell text={quote.groupLabel || ""} />
                        <CopyableCell text={quote.bidZSpread || ""} />
                        <CopyableCell text={quote.bidSpread || ""} />
                        <CopyableCell text={quote.bidGSpread || ""} />
                        <CopyableCell text={quote.bidDM || ""} />
                        <CopyableCell text={quote.bidISpread || ""} />
                        <CopyableCell text={quote.bidSpreadChg || ""} />
                        <CopyableCell text={quote.askZSpread || ""} />
                        <CopyableCell text={quote.askSpread || ""} />
                        <CopyableCell text={quote.askGSpread || ""} />
                        <CopyableCell text={quote.askDM || ""} />
                        <CopyableCell text={quote.askISpread || ""} />
                        <CopyableCell text={quote.bidPriceChgClose || ""} />
                        <CopyableCell text={quote.nextCallDate || ""} />
                        <CopyableCell text={quote.fullMaturity || ""} />
                        <CopyableCell text={quote.benchmark || ""} />
                        <CopyableCell text={quote.cdsTicker || ""} />
                        <CopyableCell text={quote.isIndicative ? "Yes" : ""} />
                        <CopyableCell text={quote.notes || ""} />
                        <CopyableCell
                          text={
                            quote.extraFields
                              ? Object.keys(quote.extraFields)
                                  .map((key: string) => `${key}: ${quote.extraFields[key]}`)
                                  .join(", ")
                              : ""
                          }
                        />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {quotes.some((quote: any) => quote.isinInferred) ? (
                <p style={{ marginTop: "6px", color: "#888", fontSize: "11px" }}>* ISIN not present in this desk's email - shown from the matched position instead.</p>
              ) : (
                ""
              )}
            </>
          ) : (
            <div style={{ padding: "30px", textAlign: "center", color: "#888", fontSize: "14px" }}>No live dealer runs found for this position.</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewDealerRuns;
